import AgentNewsAdministration from 'AgentNewsAdministration/components/AgentNewsAdministration';
import AgentNewsEntry from 'AgentNewsAdministration/components/AgentNewsEntry';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';
import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import * as React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {Redirect, Route, RouteComponentProps, Switch} from 'react-router-dom';
import Loading from 'Shared/components/Loading';
import {selectUserScopesEither} from 'Users/selectors/userProfileSelectors';
import {Scope} from 'Shared/constants/Scope';
import useOnNavigateAway from 'Shared/utilities/useOnNavigateAway';
import * as AgentNewsAdministrationRouteConstants from 'AgentNewsAdministration/AgentNewsAdministrationRouteConstants';
import {clearNewsFilter} from 'AgentNewsAdministration/ducks/news';

const AgentNewsAdministrationRoutes = () => {
  const scopes = useSelector(selectUserScopesEither);
  return pipe(
    scopes,
    E.fold(
      () => <Loading />,
      scopes => (
        <Route
          path="/agentNewsAdministration"
          render={routeProps =>
            scopes.includes(Scope.AgentNewsAdministration) || scopes.includes(Scope.AgentUsersSearch) ? (
              <AgentNewsAdministrationSubRoutes {...routeProps} />
            ) : (
              <Redirect to="/unauthorized" />
            )
          }
        />
      )
    )
  );
};

const AgentNewsAdministrationSubRoutes = ({match}: RouteComponentProps) => {
  const dispatch = useDispatch();
  useBreadcrumbs('Agent News Administration', match.url);
  useOnNavigateAway(AgentNewsAdministrationRouteConstants.NewsAdministration, () => dispatch(clearNewsFilter()));

  return (
    <Switch>
      <Route path={`${match.url}/newsEntry/:newsEntryId?`} render={() => <AgentNewsEntry />} />
      <Route path={`${match.url}`} render={() => <AgentNewsAdministration />} />
    </Switch>
  );
};

export default AgentNewsAdministrationRoutes;
